import Logo from "../assests/Logo.png"
import { Phone, Mail, MapPin } from "lucide-react"
import appConfig from "../utils/appConfig"
export default function ContactUs() {
  return (
    <div className="min-h-screen bg-white py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-10">
          <h1 className="text-3xl font-extrabold text-black">📞 Contact Us</h1>
          <div className="mt-2 w-24 h-1 bg-yellow-500 mx-auto"></div>
        </div>

        <div className="bg-white border border-yellow-200 rounded-lg shadow-lg overflow-hidden">
          <div className="p-8">
            <div className="prose prose-lg max-w-none">
              <div className="space-y-6">
                <p className="text-black leading-relaxed">
                  We're here to help! Reach out to us through any of the following channels:
                </p>

                <div className="mt-8 space-y-6">
                  <div className="flex items-start">
                    <div className="flex-shrink-0 flex items-center justify-center w-12 h-12 rounded-full bg-yellow-100 text-yellow-600">
                      <Phone className="w-6 h-6" />
                    </div>
                    <div className="ml-4">
                      <h3 className="font-bold text-black">📱 Phone:</h3>
                      <p className="text-black">
                        <a href= {`${appConfig.footerText.contactNumber}`} className="text-yellow-600 hover:underline">
                          {`${appConfig.footerText.contactNumber}`}
                        </a>
                      </p>
                    </div>
                  </div>

                  <div className="flex items-start">
                    <div className="flex-shrink-0 flex items-center justify-center w-12 h-12 rounded-full bg-yellow-100 text-yellow-600">
                      <Mail className="w-6 h-6" />
                    </div>
                    <div className="ml-4">
                      <h3 className="font-bold text-black">📧 Email:</h3>
                      <p className="text-black">
                        <a href={`${appConfig.footerText.email}`} className="text-yellow-600 hover:underline">
                        {`${appConfig.footerText.email}`}

                        </a>
                      </p>
                    </div>
                  </div>

                  <div className="flex items-start">
                    <div className="flex-shrink-0 flex items-center justify-center w-12 h-12 rounded-full bg-yellow-100 text-yellow-600">
                      <MapPin className="w-6 h-6" />
                    </div>
                    <div className="ml-4">
                      <h3 className="font-bold text-black">📍 Address:</h3>
                      <p className="text-yellow-600 hover:underline">
                      {`${appConfig.footerText.address}`}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-12 text-center">
          <div className="inline-flex items-center justify-center w-20 h-20 rounded-full">
            <img
              src={Logo || "/placeholder.svg"}
              alt="Market Analysis Academy Logo"
              className="w-full h-full object-contain"
            />
          </div>
          <p className="mt-4 text-sm text-gray-500">
            © {new Date().getFullYear()} Market Analysis Academy. All rights reserved.
          </p>
        </div>
      </div>
    </div>
  )
}
